module.exports = __webpack_public_path__ + "static/media/nandu.e4ed587c.png";